import _routes from './routes';
import GrammaPro from './component';

export const routes = _routes;
export default GrammaPro;



// WEBPACK FOOTER //
// ./containers/Group/GrammaPro/index.js